import { useParams } from "react-router-dom";
import Loading from "../../components/Loading";
import PageLayout from "../../layouts/PageLayout";
import { stockListFormatter, useGetStockListQuery } from "../../utils/stockList.utils";
import StockListAddPage from "../StockListAdd";
import { split } from "lodash";

export default function StockListEditPage() {
  const { sku } = useParams();

  const id = sku ? split(sku) : "";

  const { loading, data } = useGetStockListQuery({
    query: `?sku=${sku}`,
    options: {
      enabled: !!sku
    },
    key: `StockListEdit-${sku}`
  });

  const title = `${!!id ? "Edit" : "Add"} Stock`;

  const breadCrumbs = [
    {
      name: "Stock List",
      link: "/stock-list"
    },
    {
      name: title
    }
  ];

  const formattedData = stockListFormatter(data);

  let editItem = formattedData;

  const isLoading = loading;

  return isLoading ? (
    <PageLayout title={title} breadCrumbs={breadCrumbs}>
      <Loading loading={isLoading} />
    </PageLayout>
  ) : (
    <StockListAddPage editItem={editItem} />
  );
}
